
import { getConfig, getVenueOptionsByType } from "../../../server/config";
import {getBookedVenues} from "../../../server/api";

export const bookingStore = {
  namespaced: true,
  state() {
    return {
      bookingGeneral: {},
      bookingSearchSettings: {},
      bookingDetailSettings: {},
      bookedVenues: [],
      selectedSearchedVenue:{},
      venueSettings:[],
      temporarybookingdetails:[],
      multibookingdetails: [],
      bundleVenueSettings: [],
      venueOptions: [],
    };
  },
  mutations: {
    setBookingGeneral(state, general) {
      state.bookingGeneral = general;
    },
    setBookingSearchSettings(state, data) {
      state.bookingSearchSettings = data;
    },
    setBookingDetailSettings(state, data) {
      state.bookingDetailSettings = data;
    },
    setBookedVenues(state, data) {
      state.bookedVenues = data;
    },
    setSelectedSearchedVenue(state, data){
      state.selectedSearchedVenue = data
    },
    setVenueSettings(state, data){
      state.venueSettings = data
    },
    setVenueTypeSettings(state, data){
      state.venuetypesetting = data
    },
    setTemporarybookingdetails(state,data){
      state.temporarybookingdetails = data
    },
    setMultibookingdetails(state,data){
      state.multibookingdetails = data
    },
    setBundleVenueSettings(state, data) {
      state.bundleVenueSettings = data;
    },
    setVenueOptions(state, data) {
      state.venueOptions = data;
    }
  },
  actions: {
    async bookingGetConfig(context) {
      const [data] = await getConfig();
      context.commit("setBookingGeneral", data.generalSettings);
      context.commit("setBookingSearchSettings", data.searchSettings);
      context.commit("setBookingDetailSettings", data.detailSettings);
      context.commit("setVenueSettings", data.venueSettings);
      context.commit("setBundleVenueSettings", data.bundleVenueSettings || []);
      context.commit("setVenueTypeSettings", data.venuetypesetting);
    },
    async getBookedVenues(context, data) {
      try {
        const results = await getBookedVenues(data);
        
        // Handle new API response structure
        // API now returns: { count, data: [...], facility, message, monthYear, sources, status }
        if (results && typeof results === 'object' && !Array.isArray(results)) {
          // If it's the new response structure with data property
          if (results.data !== undefined) {
            // Extract just the data array (already filtered by venue)
            let bookingData = Array.isArray(results.data) ? results.data : [];
            
            // Deduplicate bookings with same StartDate and EndDate
            const deduplicatedBookings = [];
            const seenTimeSlots = new Set();
            
            for (const booking of bookingData) {
              // Create a unique key for each time slot
              const timeSlotKey = `${booking.StartDate}|${booking.EndDate}`;
              
              if (!seenTimeSlots.has(timeSlotKey)) {
                seenTimeSlots.add(timeSlotKey);
                deduplicatedBookings.push(booking);
              }
            }
            
            context.commit('setBookedVenues', deduplicatedBookings);
          } else {
            // Object but no data property - unexpected format
            context.commit('setBookedVenues', []);
          }
        } else if (Array.isArray(results)) {
          // Legacy format - direct array
          context.commit('setBookedVenues', results);
        } else {
          // No data or unexpected format
          context.commit('setBookedVenues', []);
        }
      } catch (error) {
        context.commit('setBookedVenues', []);
      }
    },
    async setTempBooking(context, data){
      context.commit("setTemporarybookingdetails", data);
    },
    async setMultiBookingData(context, data){
      context.commit("setMultibookingdetails", data)
    },
    async getVenueOptions(context, venueType) {
      try {
        const response = await getVenueOptionsByType(venueType);
        // Handle the API response structure: { data: { venueSettings: [...] }, message, status }
        if (response && response.data.venueSettings) {
          context.commit("setVenueOptions", response.data.venueSettings);
        } else {
          context.commit("setVenueOptions", []);
        }
      } catch (error) {
        context.commit("setVenueOptions", []);
      }
    }
 },
}